/**
 * Sarvam uses BCP-47-ish codes (en-IN, hi-IN, ...); this app's chat request
 * (`target_language`) and its language dropdown use NLLB-style codes
 * (eng_Latn, hin_Deva, ...) — see src/utils/Constant.tsx's `languageOptions`
 * equivalent in ChatInput.tsx. Voice mode has to cross this bridge in both
 * directions: STT gives back a Sarvam code, TTS wants a Sarvam code, but the
 * rest of the app only knows the NLLB ones. Scoped to the four languages
 * ChatInput.tsx's language dropdown actually offers.
 */

export const SARVAM_TO_APP_LANGUAGE: Record<string, string> = {
  "en-IN": "eng_Latn",
  "te-IN": "tel_Telu",
  "hi-IN": "hin_Deva",
  "ta-IN": "tam_Taml",
};

export const APP_TO_SARVAM_LANGUAGE: Record<string, string> = {
  eng_Latn: "en-IN",
  tel_Telu: "te-IN",
  hin_Deva: "hi-IN",
  tam_Taml: "ta-IN",
};

export function sarvamToAppLanguage(sarvamCode: string): string | null {
  return SARVAM_TO_APP_LANGUAGE[sarvamCode] || null;
}

export function appToSarvamLanguage(appCode: string): string {
  return APP_TO_SARVAM_LANGUAGE[appCode] || "en-IN";
}
